/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AsnEncodedData from './AsnEncodedData';
import AsymmetricAlgorithm from './AsymmetricAlgorithm';
import Oid from './Oid';

/**
 * The PublicKey model module.
 * @module model/PublicKey
 * @version V1
 */
class PublicKey {
    /**
     * Constructs a new <code>PublicKey</code>.
     * @alias module:model/PublicKey
     */
    constructor() { 
        
        PublicKey.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PublicKey</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PublicKey} obj Optional instance to populate.
     * @return {module:model/PublicKey} The populated <code>PublicKey</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PublicKey();

            if (data.hasOwnProperty('encodedKeyValue')) {
                obj['encodedKeyValue'] = AsnEncodedData.constructFromObject(data['encodedKeyValue']);
            }
            if (data.hasOwnProperty('encodedParameters')) {
                obj['encodedParameters'] = AsnEncodedData.constructFromObject(data['encodedParameters']);
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = AsymmetricAlgorithm.constructFromObject(data['key']);
            }
            if (data.hasOwnProperty('oid')) {
                obj['oid'] = Oid.constructFromObject(data['oid']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PublicKey</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PublicKey</code>.
     */
    static validateJSON(data) {
        // validate the optional field `encodedKeyValue`
        if (data['encodedKeyValue']) { // data not null
          AsnEncodedData.validateJSON(data['encodedKeyValue']);
        }
        // validate the optional field `encodedParameters`
        if (data['encodedParameters']) { // data not null
          AsnEncodedData.validateJSON(data['encodedParameters']);
        }
        // validate the optional field `key`
        if (data['key']) { // data not null
          AsymmetricAlgorithm.validateJSON(data['key']);
        }
        // validate the optional field `oid`
        if (data['oid']) { // data not null
          Oid.validateJSON(data['oid']);
        }

        return true;
    }


}



/**
 * @member {module:model/AsnEncodedData} encodedKeyValue
 */
PublicKey.prototype['encodedKeyValue'] = undefined;

/**
 * @member {module:model/AsnEncodedData} encodedParameters
 */
PublicKey.prototype['encodedParameters'] = undefined;

/**
 * @member {module:model/AsymmetricAlgorithm} key
 */
PublicKey.prototype['key'] = undefined;

/**
 * @member {module:model/Oid} oid
 */
PublicKey.prototype['oid'] = undefined;






export default PublicKey;

